import React from 'react';
const ChevronUpIcon = ({ width = '24px', height = '24px', fill = '#7E7E7E' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
  >
    <path d="M12 11.4L7.4 16L6 14.6L12 8.6L18 14.6L16.6 16L12 11.4Z" fill={fill} />
  </svg>
);
export default ChevronUpIcon;
